import { render, staticRenderFns } from "./QuestionAnswer.vue?vue&type=template&id=5505b6d3&scoped=true&"
import script from "./QuestionAnswer.vue?vue&type=script&lang=js&"
export * from "./QuestionAnswer.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAnswer.vue?vue&type=style&index=0&id=5505b6d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5505b6d3",
  null
  
)

export default component.exports